import { render, staticRenderFns } from "./barra_superior.vue?vue&type=template&id=5e7da7c2&"
import script from "./barra_superior.vue?vue&type=script&lang=js&"
export * from "./barra_superior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports